import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getRentalHistoryVerificationRequestsForApplicant: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/applicant/:id`
    },
    createRentalHistoryVerificationRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests`
    },
    deleteRentalHistoryVerificationRequest: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/:id`
    },
    sendRentalHistoryVerificationRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/:id/sendEmail`
    },
    resendRentalHistoryVerificationRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/:id/resendEmail`
    },
    cancelRentalHistory: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/:id/cancel`
    },
    updateRentalHistory: {
        method: 'PUT',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/:id`
    },
    getRentalHistoryVerificationRequestEmailById: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/requestEmail/:id`
    },
    getRentalHistoryVerificationRequestResponsesPdf: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/:id/responsePdf`
    },
    createRentalHistoryVerificationNote: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/note`
    },
    deleteRentalHistoryVerificationNote: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/note/:id`
    },
    updateRentalHistoryVerificationNote: {
        method: 'PUT',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/note`
    },
    getAiSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalHistoryVerificationRequests/:applicantId/aiSummary`
    }
};

export function RentalHistoryVerificationRequestsApi() {
    return createActions(actions);
}
